<template>
  <div>
    <header class="no-print">
      <CHeader fixed with-subheader light >
        <CToggler
          v-c-emit-root-event:toggle-sidebar-mobile
          in-header
          class="ml-3 d-lg-none no-print"
        />
        <CToggler
          v-c-emit-root-event:toggle-sidebar
          in-header
          class="ml-3 d-md-down-none no-print"
        />
        <CHeaderBrand
          class="mx-auto d-lg-none no-print"
          src="img/coreui-vue-logo.svg"
          width="190"
          height="46"
          alt="CoreUI Logo"
        />
        <CHeaderNav class="d-md-down-none mr-auto"> </CHeaderNav>
        <CHeaderNav class="mr-4 no-print">
          <CHeaderNavItem>
            <label class="ml-2">{{
              $store.getters.getAutenticacao.apelido
            }}</label>
          </CHeaderNavItem>
          <Notificacao />
          <PerfilDropdown />
        </CHeaderNav>
      </CHeader>
    </header>
  </div>
</template>

<script>
// import DropDownConta from "../dropdown/DropDownConta";
import PerfilDropdown from "./PerfilDropdown";
import Notificacao from "../../views/Notificacao/Notificacao";

export default {
  name: "TheHeader",
  components: {
    PerfilDropdown,
    Notificacao
    // DropDownConta
  }
};
</script>

<style scoped>



.table {
  border-collapse: collapse;
  border: 1px solid black;
  display: none;
}

.th,
td {
  border: 1px solid black;
  padding: 8px;
  text-align: center;
}
</style>
